import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import useWindowDimensions from '../../../hooks/windowDimensions';
import CloseSubPopup from '~c/popups/CloseSubPopup';
import ShowMoreButton from '~c/popups/ShowMoreButton';
import Blur from '~c/popups/Blur';

const CoursePlaybillAside = props => {
  const discount = props.text || '';

  const {width} = useWindowDimensions();

  const [isDescShown, setIsDescShown] = useState(false);

  const onShowMoreClick = () => {
    setIsDescShown(true);
  };

  const onCloseDescClick = () => {
    setIsDescShown(false);
  };

  const [isConditionForHiddenDiscount, setIsConditionForHiddenDiscount] = useState(false);

  useEffect(() => {
    const div = document.getElementsByClassName('popup-info__blocks clean-html__course-reg');
    if (div[0].clientHeight >= 110 !== isConditionForHiddenDiscount) {
      setIsConditionForHiddenDiscount(div[0].clientHeight >= 110);
    }
  }, [width, discount]);

  return (
    <div className="popup-info__aside">
      <div className={classNames("popup-info__html-container", {"shown": isDescShown})}>
        {isDescShown &&
        <CloseSubPopup closeHandler={onCloseDescClick}/>}
        <div
          dangerouslySetInnerHTML={{
            __html: discount,
          }}
          className="popup-info__blocks clean-html__course-reg"
        />
        {!isDescShown && isConditionForHiddenDiscount &&
        <Blur />}
      </div>
      {discount && isConditionForHiddenDiscount &&
      <ShowMoreButton handler={onShowMoreClick}/>}
    </div>
  );
};

export default CoursePlaybillAside;
